var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-errors',{attrs:{"error-title":"Page Not Found!"}},[_c('img',{attrs:{"slot":"error-image","src":require("../assets/errors/page-not-found.png"),"alt":""},slot:"error-image"})])}
var staticRenderFns = []

export { render, staticRenderFns }